<template>
  <div class="mt-2 mb-4">
    <router-link :to="to" class="no-underline hide-in-print">
      <div class="d-flex align-items-center">
        <span class="icon icon-navigation_pfeil_links mr-1" aria-hidden="true"></span>
        <span class="hover-underline">{{ $t(i18nMessage) }}</span>
      </div>
    </router-link>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { RouteLocationRaw } from 'vue-router';

export default defineComponent({
  name: 'LinkBack',
  props: {
    i18nMessage: {
      type: String,
      required: true
    },
    to: {
      type: [String, Object] as PropType<RouteLocationRaw|string>,
      required: true
    },

  }
});
</script>

<style scoped>
.icon{
  font-size: 24px;
  padding-top:2px;
}
</style>
